import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

import SimpleButton from "../../Buttons/SimpleButton.js";

import ConsultantsImageOne from "../../Global/images/consultantImageOne.png";
import ConsultantsImageTwo from "../../Global/images/consultantImageTwo.png";
import ConsultantsImageThree from "../../Global/images/consultantImageThree.png";
import ConsultantsImageFour from "../../Global/images/consultantImageFour.png";

const StyledConsultantsBlock = styled(NanoFlex)`
  height: auto;
  padding: 0 100px;
  gap: 36px;

  .consultantsInfoBlock {
    gap: 36px;
    .consultantsTitle {
      h3 {
        color: ${(props) => props.theme.color.primaryColors.fontColor};
      }
    }

    .consultantsInfo {
      h5 {
        text-transform: none;
        color: ${(props) => props.theme.color.primaryColors.darkPurple};
      }
    }
  }

  .consultantsAreaCarroussel {
    gap: 32px;
    height: 510px;

    .carrousselItem {
      flex: 1 calc(25% - 32px);
      position: relative;
      overflow: hidden;
      border-radius: 10px;
      cursor: pointer;

      .imageBackground {
        position: absolute;
        object-fit: cover;
        width: 100%;
        height: 100%;
        transition: ${(props) => props.theme.transition};

        img {
          min-height: 100%;

          min-width: 100%;
          object-fit: cover;
          width: auto;
          transition: ${(props) => props.theme.transition};
        }
      }

      button {
        pointer-events: none;
      }

      .carrousselContent {
        padding: 10px;
        position: relative;
        z-index: 5;
        opacity: 0;
        overflow: hidden;
        width: 0;
        height: 100%;
        transition: ${(props) => props.theme.transition};

        button {
          white-space: nowrap;
        }
      }

      &.active {
        min-width: calc(40% - 32px);

        .carrousselContent {
          opacity: 1;
          overflow: hidden;
          width: 100%;
          height: 100%;
          transition: ${(props) => props.theme.transition};
        }
      }
    }
  }

  /* SMALL DESKTOPS */
  @media only screen and (max-width: 1450px) {
    padding: 0px 50px;
    .consultantsAreaCarroussel {
      height: 400px;

      .carrousselItem {
        &.active {
          min-width: calc(50% - 32px);
        }
      }
    }
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    padding: 0px 30px;

    .consultantsAreaCarroussel {
      height: 400px;

      .carrousselItem {
        &.active {
          min-width: calc(70% - 32px);
        }
      }
    }
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    padding: 0px 20px;
    height: auto;

    .consultantsInfoBlock {
      gap: 16px;
      height: auto;

      .consultantsTitle {
        height: auto;
      }
      .consultantsInfo {
        height: auto;
      }
    }
    .consultantsAreaCarroussel {
      gap: 16px;

      .carrousselItem {
        border-radius: 5px;
        .carrousselContent {
          button {
            white-space: normal;
          }
        }
      }
    }
  }

  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
    .consultantsInfoBlock {
      .consultantsTitle {
        h3 {
          font-size: 24px;
          text-align: left;
          font-weight: 600;
        }
      }
      .consultantsInfo {
        h5 {
          text-align: left;
          font-size: 12px;
          line-height: 15px;
        }
      }
    }

    .consultantsAreaCarroussel {
      height: auto;
      gap: 16px;
      flex-wrap: wrap;

      .carrousselItem {
        height: 279px;
        max-width: 50%;
        flex: 1 calc(50% - 16px);

        &.active {
          min-width: unset;
        }

        .carrousselContent {
          display: flex;

          .button {
            width: 100%;
            button {
              width: 100%;
              justify-content: center;
            }
          }
        }
      }
    }
  }

  /* MOBILE SMALL*/
  @media only screen and (max-width: 390px) {
    padding: 0 16px;
  }
`;

export default class ConsultantsBlock extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      carrousselIndex: 0,
    };

    this.carrousselInterval = null;
  }

  componentDidMount() {
    super.componentDidMount();

    this.carrousselInterval = setInterval(this.loopCarroussel, 4000);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  loopCarroussel = () => {
    let newCarrousselIndex = this.state.carrousselIndex + 1;

    if (newCarrousselIndex > 3) newCarrousselIndex = 0;

    this.setState({ carrousselIndex: newCarrousselIndex });
  };

  mouseEnter = () => {
    clearInterval(this.carrousselInterval);
  };

  mouseLeave = () => {
    this.carrousselInterval = setInterval(this.loopCarroussel, 4000);
  };

  render() {
    return (
      <StyledConsultantsBlock flexDirection="column" className="consultantsBlock">
        <NanoFlex className="consultantsInfoBlock" flexDirection="column">
          <NanoFlex className="consultantsTitle" justifyContent="flex-start">
            <Type.h3>{this.translation.homepage.consultantsBlock.consultantsBlockTitle}</Type.h3>
          </NanoFlex>
          <NanoFlex className="consultantsInfo" justifyContent="flex-start">
            <Type.h5>{this.translation.homepage.consultantsBlock.consultantsBlockText}</Type.h5>
          </NanoFlex>
        </NanoFlex>

        <NanoFlex className="consultantsAreaCarroussel">
          <NanoFlex className={`carrousselItem ${this.state.carrousselIndex === 0 ? "active" : ""}`} onClick={() => this.setState({ carrousselIndex: 0 })} onMouseEnter={() => this.mouseEnter()} onMouseLeave={() => this.mouseLeave()}>
            <NanoFlex className="imageBackground" alignItems="flex-start">
              <img src={ConsultantsImageOne} alt="" />
            </NanoFlex>
            <NanoFlex className="carrousselContent" justifyContent="flex-start" alignItems="flex-end">
              <SimpleButton label={this.translation.homepage.consultantsBlock.financeAdministrative}></SimpleButton>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className={`carrousselItem ${this.state.carrousselIndex === 1 ? "active" : ""}`} onClick={() => this.setState({ carrousselIndex: 1 })} onMouseEnter={() => this.mouseEnter()} onMouseLeave={() => this.mouseLeave()}>
            <NanoFlex className="imageBackground" alignItems="flex-start">
              <img src={ConsultantsImageTwo} alt="" />
            </NanoFlex>
            <NanoFlex className="carrousselContent" justifyContent="flex-start" alignItems="flex-end">
              <SimpleButton label={this.translation.homepage.consultantsBlock.itTelco}></SimpleButton>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className={`carrousselItem ${this.state.carrousselIndex === 2 ? "active" : ""}`} onClick={() => this.setState({ carrousselIndex: 2 })} onMouseEnter={() => this.mouseEnter()} onMouseLeave={() => this.mouseLeave()}>
            <NanoFlex className="imageBackground" alignItems="flex-start">
              <img src={ConsultantsImageThree} alt="" />
            </NanoFlex>
            <NanoFlex className="carrousselContent" justifyContent="flex-start" alignItems="flex-end">
              <SimpleButton label={this.translation.homepage.consultantsBlock.engineeringLogistics}></SimpleButton>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className={`carrousselItem ${this.state.carrousselIndex === 3 ? "active" : ""}`} onClick={() => this.setState({ carrousselIndex: 3 })} onMouseEnter={() => this.mouseEnter()} onMouseLeave={() => this.mouseLeave()}>
            <NanoFlex className="imageBackground" alignItems="flex-start">
              <img src={ConsultantsImageFour} alt="" />
            </NanoFlex>
            <NanoFlex className="carrousselContent" justifyContent="flex-start" alignItems="flex-end">
              <SimpleButton label={this.translation.homepage.consultantsBlock.commercialMarketing}></SimpleButton>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledConsultantsBlock>
    );
  }
}
